<template>
  <div class="pc_bottom-button">
    <div class="btnTips">{{ $t('PCBottomButton.index.647hqss75ac0') }}</div>
    <div class="bottom-main">
   
      <div class="bottom-main-right">
        <div>
          <div class="bottom-main-text">
            <span class="moneyTitle">{{ moneyTitle }}: </span>
            <span class="subsidy-span">
              <span class="dun">{{ data.currencySymbol }}</span>
              {{ Number(data.evaluation) || 0}}
            </span>
          </div>
          <div class="bottom-main-left">
            <template v-if="showSelect">
              <img
                v-if="select"
                src="@/assets/PC/img/select.png"
                alt=""
                class="selectIcon"
                @click="select = !select"
              />
              <img
                v-else
                src="@/assets/PC/img/unselect.png"
                alt=""
                class="selectIcon"
                @click="select = !select"
              />
              {{ $t('PCBottomButton.index.647hqss760c0') }} &nbsp;
              <span @click="goto(1)"
                >{{ $t('PCBottomButton.index.647hqss764w0') }} </span
              >
              &nbsp;& &nbsp;
              <span @click="goto(2)">{{ $t('PCBottomButton.index.647hqss76ac0') }}</span>
            </template>
          </div>
        </div>
        <el-button class="button" :loading="loading" :disabled="isDisabled" @click="handleSubmit">{{
          btnName
        }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { vm } from '@/locales';
export default {
  name: 'PCBottomButton',
  props: {
    data: {
      type: Object,
      default: {}
    },
    activeMoney: {
      type: Object
    },
    preMoney: Number,
    disabled: {
      type: Boolean,
      default: false
    },
    btnName: {
      type: String,
      default: vm.$t('PCBottomButton.index.647hqss76dg0') // '我要下单'
    },
    moneyTitle: {
      type: String,
      default: vm.$t('PCBottomButton.index.647hqss76gw0')
    },
    loading: {
      type: Boolean,
      default: false
    },
    showSelect: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isDisabled() {
      if (this.showSelect) {
        // if (this.select && !this.disabled) {
        //   return false;
        // } else {
        //   return true;
        // }
        if (!this.disabled) {
          return false;
        } else {
          return true;
        }
      
      } else {
        return this.disabled;
      }
    }
  },
  data() {
    return {
      select: false
    };
  },
  methods: {
    handleSubmit() {
      if(this.showSelect){
        if (this.select){
          this.$emit('handleSubmit');
        }else{
          // this.$toast(this.$t('component.tradeInProcess.toastTip'));
          this.$message.error(this.$t('component.tradeInProcess.toastTip'));
        }
      }else{
        this.$emit('handleSubmit');
      }
    },
    goto(type) {
      if (type == 1) {
        // this.$router.push({ name: 'PrivacyPolicy' }); 
        this.$router.push({ name: 'cookiePriva' }); 
      } else {
        this.$router.push({ name: 'TermsAndConditions' });
      }
    }
  }
};
</script>

<style scoped lang="less">
.pc_bottom-button {
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 128px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  z-index: 999;
  flex-direction: column;
  align-items: center;
  .btnTips {
    height: 40px;
    color: var(--eSwop_Theme1, #ff8a14);
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    background: #fff5eb;
    width: 100%;
    line-height: 40px;
  }
  .subsidy-span {
    color: #ff7b24;
    font-weight: 600;
    font-size: 32px;
    line-height: 1;
  }
  .bottom-main {
    width: 1200px;
    text-align: right;
    //background-color: #6facf4;
    display: flex;
    justify-content: flex-end;
    height: 88px;
    // line-height: 88px;
    // align-items: center;
    .bottom-main-left {
      display: flex;
      //width: 200px;
      align-items: center;
      .selectIcon {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
      span {
        color: #ff9600;
        cursor: pointer;
      }
    }
    .bottom-main-right {
      display: flex;
      align-items: center;
    }
    .bottom-main-text {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    .moneyTitle {
      color: #333;
      text-align: right;
      font-family: 'PingFang SC';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-right: 20px;
    }
    .el-button {
      margin-left: 40px;
      width: 200px;
      height: 48px;
      background-color: #ff8a14;
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      border-radius: 4px;
      border: none;
    }
    .dun {
      font-size: 24px;
    }
    .is-disabled {
      background-color: #ffd0a1 !important;
    }
  }
}
</style>
